import { ReactElement } from 'react';

import {
   ConfidentialResourceAccessRequestAcceptCommand,
   ConfidentialResourceAccessRequestQuery,
   Practitioner,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { Choice } from '@dreryk/watermelon';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { createInterpolatedTranslationKey, practitionerNameFormatter } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../translations';

import { ReviewRequestFormBean, ReviewRequestFormController } from './form/ReviewRequestForm.types';

type ReviewRequestAcceptButtonProps = {
   requestId: number;
   grantee: Practitioner;
   onSuccess: VoidFunction;
   handleSubmit: ReviewRequestFormController['handleSubmit'];
};

export const ReviewRequestAcceptButton = (props: ReviewRequestAcceptButtonProps): ReactElement => {
   const { executeAsync } = useCqrsCommand<void, ReviewRequestFormBean>(
      (parameters) => {
         const command = new ConfidentialResourceAccessRequestAcceptCommand();
         command.requestId = props.requestId;
         command.decisionJustification = Choice.withUseDefaultIfNull(parameters.decisionJustification);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               createInterpolatedTranslationKey(systemActivityTranslationKeys.acceptSuccess, {
                  practitionerName: practitionerNameFormatter(props.grantee),
               })
            );
            refetchCqrsQuery(ConfidentialResourceAccessRequestQuery);
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         testId={'acceptAccess'}
         label={systemActivityTranslationKeys.grantAccess}
         onClick={props.handleSubmit(executeAsync)}
      />
   );
};
